import {Pagination} from 'platform/components';
import {Box, Show, Spinner} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useDetailPagination} from '../hooks/useDetailPagination';

export type RowControlProps = {
  onChange: (entityIndex: string, sourceSearchParams: string) => void;
  count: number;
};
export const RowControl = (props: RowControlProps) => {
  const {rowIndex, isInvalid, onPageChange, ids} = useDetailPagination(props.onChange);
  const hasNoIds = isNilOrEmpty(ids.current);

  if (isInvalid) {
    return null;
  }

  return (
    <Box position="relative">
      <Show when={hasNoIds}>
        <Spinner variant="overlay" size="small" />
      </Show>
      <Pagination
        isDisabled={hasNoIds}
        variant="text-only"
        showPrevButton
        showNextButton
        page={rowIndex}
        pagesQuantity={props.count}
        onPageChange={onPageChange}
      />
    </Box>
  );
};
